import { Tag } from "antd";
import ShowStatus from "../Components/ReusableComponents/ShowStatus";

export const DepartmentCompHeader = [
  { field: 'serialNo', headerName: 'S.NO' },
  { field: 'department_name', headerName: 'DEPARTMENTS' },
  { field: 'department_head_name', headerName: 'DEPARTMENTS HEAD' },
  { field: 'createdAt', headerName: 'CREATED DATE' },
  { field: 'created_By_name', headerName: 'CREATED BY' },
  { field: 'updatedAt', headerName: 'UPDATED DATE' },
  { field: 'modified_By_Name', headerName: 'UPDATED BY' },
  { field: 'status', headerName: 'STATUS' },
];
export const QualificationHeader = [
  { field: 'serialNo', headerName: 'S.NO' },
  { field: 'qualification_name', headerName: 'QUALIFICATION' },
  { field: 'createdAt', headerName: 'CREATED DATE' },
  { field: 'updatedAt', headerName: 'UPDATED DATE' },
  { field: 'status', headerName: 'STATUS' },
];
export const TrainingsTableColmns = [
  { field: 'serialNo', headerName: 'S.NO' },
  { field: 'trainingName', headerName: 'TRAINING NAME' },
  { field: 'trainers', headerName: 'TRAINERS' },
  { field: 'trainees', headerName: 'TRAINEES' },
  { field: 'duration', headerName: 'DURATION' },
   { field: 'training_status', headerName: 'STATUS' },
];

export const DesignationcompHeader = [
  { field: 'serialNo', headerName: 'S.NO' },
  { field: 'designation_name', headerName: 'DESIGNATIONS' },
  { field: 'createdAt', headerName: 'CREATED DATE' },
  { field: 'created_By_name', headerName: 'CREATED BY' },
  { field: 'updatedAt', headerName: 'UPDATED DATE' },
  { field: 'modified_By_Name', headerName: 'UPDATED BY' },
  { field: 'status', headerName: 'STATUS' },
];
export const emailComponentHeader = [
  { field: 'serialNo', headerName: 'S.NO' },
  { field: 'title', headerName: 'TITLE' },
  { field: 'subject', headerName: 'SUBJECT' },
  { field: 'department_name', headerName: 'DEPARTMENTS' },
  { field: 'createdAt', headerName: 'CREATED DATE' },
  { field: 'status', headerName: 'STATUS' },
];

export const SurveyPeriodTableHeader = [
  { field: 'serialNo', headerName: 'S.NO' },
  { field: 'period_name', headerName: 'TITLE' },
  { field: 'fromMonth', headerName: 'FROM MONTH' },
  { field: 'toMonth', headerName: 'TO MONTH' },
  { field: 'createdAt', headerName: 'CREATED DATE' },
  { field: 'updatedAt', headerName: 'UPDATED DATE' },
  { field: 'status', headerName: 'STATUS' },
];

export const SurveyCategoryHeader = [
  { field: 'serialNo', headerName: 'S.NO' },
  { field: 'categoryName', headerName: 'CATEGORY NAME' },
  { field: 'createdAt', headerName: 'CREATED DATE' },
  { field: 'updatedAt', headerName: 'UPDATED DATE' },
  { field: 'status', headerName: 'STATUS' },
];
export const surveyHeader = [
  { field: 'serialNo', headerName: 'S.NO', className: '' ,align: 'center'},
  { field: 'title', headerName: 'SURVEY TITLE', className: '' },
  { field: 'question_count', headerName: 'NO OF QUESTIONS', className: '',align: 'center' },
  { field: 'Start_date', headerName: 'START DATE', className: '' ,align: 'center'},
  { field: 'end_date', headerName: 'END DATE', className: '' ,align: 'center'},{ field: 'period', headerName: 'PERIOD', className: '' ,align: 'center'},
  { field: 'completion_status', headerName: ' COMPLETION STATUS' ,align: 'center'},
  { field: 'approval_status', headerName: 'APPROVAL STATUS' ,align: 'center'},
  { field: 'status', headerName: 'STATUS' ,align: 'center'},
];
export const surveyReportHeader = [
  { field: 'serialNo', headerName: 'S.NO', align: 'center' },
  { field: 'survey_name', headerName: 'SURVEY TITLE' },
  { field: 'no_of_questions', headerName: 'NO OF QUESTIONS', align: 'center' },
  { field: 'start_date', headerName: 'START DATE', align: 'center' },
  { field: 'end_date', headerName: 'END DATE', align: 'center' },
    { field: 'period', headerName: 'PERIOD', align: 'center' },
  { field: 'totalAssigned', headerName: 'TOTAL ASSIGNED', align: 'center' },
  { field: 'totalAttended', headerName: 'TOTAL ATTENDED', align: 'center' },
  { field: 'totalNotAttended', headerName: 'TOTAL NOT ATTENDED', align: 'center' },
];
export const Mysurvey = [
  { field: 'serialNo', headerName: 'S.NO', width: 60 },
  { field: 'title', headerName: 'SURVEY TITLE', minWidth: 200 },
  { field: 'startDate', headerName: 'START DATE' },
  { field: 'endDate', headerName: 'DUE DATE' },
  { field: 'totalQuestions', headerName: 'NO OF QUESTIONS',align: 'center'},
 { field: 'completion_status', headerName: 'COMPLETION STATUS ',align: 'center' },
];
export const approveTable = [
  { field: "serialNo", headerName: "S.NO", className: "" },
  { field: 'title', headerName: 'SURVEY TITLE', className: '' },


  { field: 'start_date', headerName: 'START DATE', className: '' },
  { field: 'end_date', headerName: 'END DATE', className: '' },
   { field: 'type', headerName: 'PERIOD', className: '' ,align: 'center'},
   { field: 'questionCount', headerName: 'NO OF QUESTIONS', className: '' ,align: 'center' },
   { 
     field: 'progress', 
     headerName: 'STATUS', 
     className: '',
     render: (progress) => <ShowStatus status={progress} />
   },
   
];

export const surveyBasedUsersHeader = [
  { field: 'serialNo',          headerName: 'S.NO',               align: 'center' },
  { field: 'userName',          headerName: 'USER NAME' },
  { field: 'completion_status', headerName: 'COMPLETION STATUS',  align: 'center' },
  { field: 'completedDate',     headerName: 'COMPLETION DATE',    align: 'center' },
];


export const leaveCompHeader = [
  { field: 'serialNo', headerName: 'S.NO' },
  { field: 'holiday_name', headerName: 'PUBLIC HOLIDAYS' },
  { field: 'date_of_holiday_table', headerName: 'DATE' },
  { field: 'createdAt', headerName: 'CREATED DATE' },
  { field: 'created_By_name', headerName: 'CREATED BY' },
  { field: 'updatedAt', headerName: 'UPDATED DATE' },
  { field: 'modified_By_Name', headerName: 'UPDATED BY' },
];
export const myRequestLeaveHeaders = [
  // { field: "sno", headerName: "S.NO", className: "" },
  { field: 'serialNo', headerName: 'S.NO', className: '' },
  { field: 'type', headerName: 'TYPE', className: '' },
  { field: 'startDate', headerName: 'START DATE', className: '' },
  { field: 'endDate', headerName: 'END DATE', className: '' },
  { field: 'daycount', headerName: 'DAYS', className: '' },
  { field: 'reason', headerName: 'REASON', className: '' },
  { field: 'status', headerName: 'STATUS', className: '' },
];

export const userRequestPermissionHeaders = [
  { field: 'serialNo', headerName: 'S.NO', className: '' },
  { field: 'employee_name', headerName: 'EMPLOYEE NAME', className: '' },
  { field: 'type', headerName: 'TYPE', className: '' },
  { field: 'dateString', headerName: 'DATE', className: '' },
  { field: 'month', headerName: 'MONTH', className: '' },
  { field: 'year', headerName: 'YEAR', className: '' },
  { field: 'timeSpent', headerName: 'PERMISSION TIME', className: '' },
  { field: 'hourCount', headerName: 'TOTAL HOURS', className: '' },
  { field: 'reason', headerName: 'REASON', className: '' },
  { field: 'status', headerName: 'STATUS', className: '' },
];

export const myRequestPermissionHeaders = [
  { field: 'serialNo', headerName: 'S.NO', className: '' },
  { field: 'dateString', headerName: 'DATE', className: '' },
  { field: 'month', headerName: 'MONTH', className: '' },
  { field: 'year', headerName: 'YEAR', className: '' },
  { field: 'timeSpent', headerName: 'PERMISSION TIME', className: '' },
  { field: 'hourCount', headerName: 'TOTAL HOURS', className: '' },
  { field: 'reason', headerName: 'REASON', className: '' },
  { field: 'status', headerName: 'STATUS', className: '' },
];
export const userRequestsLeaveHeaders = [
  // { field: "sno", headerName: "S.NO", className: "" },
  { field: 'serialNo', headerName: 'S.NO', className: '' },
  { field: 'employee_name', headerName: 'EMPLOYEE NAME', className: '' },
  // { field: 'employee_code', headerName: 'EMPLOYEE CODE', className: '' },
  { field: 'type', headerName: 'TYPE', className: '' },
  { field: 'startDate', headerName: 'START DATE', className: '' },
  { field: 'endDate', headerName: 'END DATE', className: '' },
  { field: 'daycount', headerName: 'DAYS', className: '' },
  { field: 'reason', headerName: 'REASON', className: '' },
  { field: 'status', headerName: 'STATUS', className: '' },
  // { field: "action", headerName: "ACTION", className: "" },
];
 export const questionTableColumns = [
 
    {  field: 'serialNo' ,headerName: 'S.NO',},
    {  field: 'question',headerName: 'QUESTION', },
    {field: 'type',headerName: 'TYPE' },
  // Change 'catogoryName' to 'categoryName'
{ field: 'categoryName', headerName: 'CATEGORY' },
  
     
    {  field: 'createdAt' ,headerName: 'CREATED DATE',},
  

    { field: 'status', headerName: 'STATUS', }, ]
export const PermissionsTaken = [
  // { field: "sno", headerName: "S.NO", className: "" },
  { field: 'serialNo', headerName: 'S.NO', className: '' },
  { field: 'employeeName', headerName: 'EMPLOYEE', className: '' },
  { field: 'date', headerName: 'DATE', className: '' },
];
export const EmployeesleaveTaken = [
  { field: 'serialNo', headerName: 'S.NO', className: '' },
  { field: 'employeeName', headerName: 'EMPLOYEE', className: '' },
  { field: 'date', headerName: ' DATE', className: '' },
  // { field: 'endDate', headerName: 'TO DATE', className: '' },
  // { field: 'dayCount', headerName: 'LEAVE COUNT', className: '' },
  { field: 'type', headerName: 'LEAVE TYPE', className: '' },
];
export const reviewHeader = [
  { field: 'serialNo', headerName: 'S.NO' },
  { field: 'employeeCode', headerName: 'EMPLOYEE CODE' },
  { field: '_userName', headerName: 'NAME' },
  { field: 'designation', headerName: 'DESIGNATION' },
  { field: 'department', headerName: 'DEPARTMENT' },
  { field: 'email', headerName: 'EMAIL ID' },
  { field: 'phone', headerName: 'PHONE' },
];

export const TrainingsCalendarColumns = [
  { field: 'sNo', headerName: 'S. NO' },
  { field: 'category', headerName: 'CATEGORY' },
  { field: 'type', headerName: 'TYPE' },
  { field: 'trainingName', headerName: 'NAME OF TRAINING' },
  { field: 'trainers', headerName: 'TRAINERS' },
  { field: 'days', headerName: 'TRAINING DAYS' },
  { field: 'participants', headerName: 'NAME OF THE PARTICIPANTS' },
  { field: 'trainees', headerName: 'NO OF TRAINEES' },
  { field: 'date_of_training', headerName: 'DATE OF TRAINING' },
 {
  field: 'status',
  headerName: 'STATUS OF TRAINING',
  render: (status) => {
   
    const s = status?.toLowerCase().trim();

    const colorConfig = {
      completed: {
        text: '#437d70',
        bg: '#e6f4f1',
        border: '#bcdbd3',
      },
      ongoing: {
        text: '#96701c', 
        bg: '#fff9e6',   
        border: '#ffe58f', 
      },
      upcoming: {
        text: '#0050b3', 
        bg: '#e6f7ff',   
        border: '#91d5ff', 
      },
      default: {
        text: '#595959',
        bg: '#f5f5f5',
        border: '#d9d9d9',
      },
    };

    const style = colorConfig[s] || colorConfig.default;

    return (
      <span
        style={{
          color: style.text,
          backgroundColor: style.bg,
          border: `1.2px solid ${style.border}`,
          padding: '2px 14px',
          borderRadius: '20px', 
          fontSize: '13px',
          fontWeight: 500,
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          minWidth: '95px',
          textTransform: 'capitalize',
          lineHeight: '1.4',
        }}
      >
        {status || '--'}
      </span>
    );
  },
},
  { field: 'feedback_date', headerName: 'FEEDBACK DATE' },
  // { field: 'evaluation_date', headerName: 'EVALUATION DATE' },
];
